module.exports = __webpack_public_path__ + "img/discontinued-color-icon.6a4a9d75.svg";